import Orders from "./classes/Orders";

window.onload = function() {
    new Orders()
}